// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mine-arrow-cell[data-v-f8783c64]{width:100%;height:11.73333vw;display:flex;align-items:center;justify-content:space-between}.mine-arrow-cell-arrow[data-v-f8783c64]{width:2.4vw;height:4vw}.mine-list-item[data-v-f8783c64]{display:flex;align-items:center}.mine-list-item-title[data-v-f8783c64]{color:#000;font-size:3.73333vw;margin-left:5.86667vw}", ""]);
// Exports
module.exports = exports;
